//
export default class AccAccountingSeatConceptHeaders {

  /**
   * 
   */
  static toList() {
    return [
      {
        text: '#',
        value: 'id',
      },
      {
        text: 'codigo',
        value: 'code',
      },
      {
        text: 'concepto',
        value: 'concept',
      },
      {
        text: 'removible',
        align: 'center',
        format: 'boolean',
        value: 'removable',
      },
      {
        text: 'modificado',
        align: 'right',
        format: 'datetime',
        value: 'updated_at',
      },
    ]
  } 
}